import React, { FC } from 'react';
import { Box, Checkbox, Typography } from '@mui/material';
import { CommonProps, ICategory } from './constants';
import { IconArrowDown, IconArrowUp, IconDash } from '../../../utils/icons';

interface Props extends CommonProps {
  category: ICategory;
  layer: number;
  shouldShow: boolean;
  onToggle: (shouldShow: boolean) => void;
}

export const CategoryName: FC<Props> = ({
  category,
  shouldShow,
  onToggle,
  selector,
  layer,
}) => (
  <Box className="flex gap-4 items-center" sx={{ paddingLeft: layer * 4 }}>
    <Box className="w-8 h-8 items-center justify-center flex">
      {!!category.child_categories.length && (
        <Box
          className="cursor-pointer"
          sx={{ color: shouldShow ? 'var(--text)' : 'var(--muted)' }}
          onClick={() => onToggle(!shouldShow)}
        >
          {shouldShow ? (
            <IconArrowUp stroke="currentColor" />
          ) : (
            <IconArrowDown stroke="currentColor" />
          )}
        </Box>
      )}
      {!category.child_categories.length && (
        <Box sx={{ color: 'var(--muted)' }}>
          <IconDash fill="currentColor" />
        </Box>
      )}
    </Box>
    {selector && (
      <Checkbox
        disabled={selector.currentCategoryId === category.id}
        checked={selector.selectedId === category.id}
        onChange={(ev) =>
          selector.onSelect?.(ev.target.checked ? category.id : null)
        }
      />
    )}
    <Typography variant="body2">{category.name}</Typography>
  </Box>
);
